


















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Header from '@/components/Header.vue'
import Banner from '@/views/reservation/molecules/Banner.vue'
import { initReservationFormViewModel } from '@/models/ReservationFormViewModel'
import { AlertModule } from '@/store/modules/alert'
import ReturnTopButton from './atoms/ReturnTopButton.vue'
import RequiredBadge from './atoms/RequiredBadge.vue'
import { formatDate, formatUuid } from '@/utils'
import Constants from '@/utils/constants'
import { RouteName } from '@/router'
import Indicator from '@/views/reservation/molecules/Indicator.vue'
import { ReservationForm } from '@/store/modules/form'
import { getSex } from '@/utils/app-setting'
import { createWebFormInfo } from '@/api/web-form'

@Component({
  name: 'ReservationConfirm',
  components: {
    Header,
    Banner,
    ReturnTopButton,
    RequiredBadge,
    Indicator
  }
})
export default class ReservationConfirm extends Vue {
  // フォーム情報
  public reservationForm = initReservationFormViewModel()
  public selectedFormatDate = ''
  public selectedFormatFirstChoiceDate = ''
  public selectedFormatSecondChoiceDate = ''
  // 初診・再診オプション
  public isFirstTreatmentRadioOption = Constants.IsFirstTreatmentRadioOption
  // 診察タイプカテゴリ
  public treatmentCategoryOption = Constants.TreatmentCategoryOption

  public isErrorAlertOpen = false
  private isWarningAlertOpen = false
  private canFaceToFace = false
  private canOnlineTreatment = false
  private loading = false

  private get errorTime() {
    return AlertModule.errorTime
  }

  private get errorAlertMessage() {
    return AlertModule.errorAlertMessage
  }

  private get warningTime() {
    return AlertModule.warningTime
  }

  private get warningAlertMessage() {
    return AlertModule.warningAlertMessage
  }

  @Watch('errorTime')
  private async onErrorTimeChange() {
    this.isErrorAlertOpen = true
  }

  @Watch('warningTime')
  private async onWarningTimeChange() {
    this.isWarningAlertOpen = true
  }

  created() {
    if (!ReservationForm.clinic.medicalBusinessId) {
      this.$router.push({ name: RouteName.RESERVATION })
    }
    this.setReservationForm()
    // this.selectedFormatDate = formatDate(
    //   this.reservationForm.reservationDate,
    //   Constants.DateFormat.YYYYNEN_MMGATU_DDNICHI_ZIHUN
    // )
    this.selectedFormatFirstChoiceDate = formatDate(
      this.reservationForm.firstChoice.reservationDate,
      Constants.DateFormat.YYYYNEN_MMGATU_DDNICHI_YOUBI
    )
    this.selectedFormatSecondChoiceDate = formatDate(
      this.reservationForm.secondChoice.reservationDate,
      Constants.DateFormat.YYYYNEN_MMGATU_DDNICHI_YOUBI
    )
  }

  private setReservationForm() {
    this.reservationForm.clinic.medicalBusinessId =
      ReservationForm.clinic.medicalBusinessId
    this.reservationForm.clinic = ReservationForm.clinic
    this.reservationForm.treatmentCategoryName =
      ReservationForm.treatmentCategoryName
    // this.reservationForm.desiredTreatment = ReservationForm.desiredTreatment
    this.reservationForm.isFirstTreatment = ReservationForm.isFirstTreatment
    this.reservationForm.reservationDate = ReservationForm.reservationDate
    this.reservationForm.firstChoice = ReservationForm.firstChoice
    this.reservationForm.secondChoice = ReservationForm.secondChoice
    this.reservationForm.firstName = ReservationForm.firstName
    this.reservationForm.lastName = ReservationForm.lastName
    this.reservationForm.birthYear = ReservationForm.birthYear
    this.reservationForm.birthMonth = ReservationForm.birthMonth
    this.reservationForm.birthDate = ReservationForm.birthDate
    this.reservationForm.phoneNumber = ReservationForm.phoneNumber
    this.reservationForm.email = ReservationForm.email
    this.reservationForm.contactTool = ReservationForm.contactTool
    this.reservationForm.comment = ReservationForm.comment
    this.reservationForm.treatmentSpotId = ReservationForm.treatmentSpotId
  }

  public async reserve() {
    // 登録APIを呼び出し
    this.loading = true
    const medicalWebFormTreatment = {
      treatment_category_name: this.reservationForm.treatmentCategoryName,
      // desired_treatment: this.reservationForm.desiredTreatment,
      reservation_detail: Constants.IsFirstTreatment(
        this.reservationForm.isFirstTreatment
      )
        ? 'first_treatment'
        : 'counseling',
      first_choice: {
        reservation_date:
          this.reservationForm.firstChoice.reservationDate ?? new Date(),
        is_am: !!this.reservationForm.firstChoice.isAm
      },
      second_choice: {
        reservation_date:
          this.reservationForm.secondChoice.reservationDate ?? new Date(),
        is_am: !!this.reservationForm.secondChoice.isAm
      },
      first_name_kana: this.reservationForm.firstName,
      last_name_kana: this.reservationForm.lastName,
      birthdate: formatDate(
        new Date(
          this.reservationForm.birthYear,
          this.reservationForm.birthMonth - 1,
          this.reservationForm.birthDate
        ),
        Constants.DateFormat.YYYY_MM_DD_HYPHEN
      ),
      phone_number: this.reservationForm.phoneNumber,
      email: this.reservationForm.email,
      contact_tool: this.reservationForm.contactTool,
      comment: this.reservationForm.comment,
      sex: getSex()
    }
    const res = await createWebFormInfo(
      this.reservationForm.clinic.medicalBusinessId,
      formatUuid(this.reservationForm.clinic.clinicId),
      medicalWebFormTreatment
    )
    if (res.result) {
      // 登録成功したら確認画面に遷移する
      const dataLayer = (window as any).dataLayer || []
      dataLayer.push({
        transactionId: res.id,
        transactionAffiliation: '',
        transactionTotal: 0,
        transactionProducts: [
          {
            sku: formatUuid(this.reservationForm.clinic.clinicId),
            name: this.reservationForm.clinic.name,
            price: 0,
            quantity: 0
          }
        ]
      })
      dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
      dataLayer.push({
        event: 'purchase',
        ecommerce: {
          transaction_id: res.id,
          affiliation: '',
          currency: 'JPY',
          items: [
            {
              item_name: this.reservationForm.clinic.name,
              item_id: formatUuid(this.reservationForm.clinic.clinicId)
            }
          ]
        }
      })
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = `https://js.felmat.net/fmcv.js?adid=W51515&uqid=${res.id}`
      document.head.appendChild(script)

      const span = document.createElement('span')
      span.id = 'a8sales'
      document.body.appendChild(span)

      const affiliateStaticScript = document.createElement('script')
      affiliateStaticScript.src = '//statics.a8.net/a8sales/a8sales.js'
      document.body.appendChild(affiliateStaticScript)

      this.addAffiliagteTag(res.id)

      ReservationForm.setReservationForm(initReservationFormViewModel())
      this.$router.push({ name: RouteName.RESERVATION_COMPLETE })
    }
    this.loading = false
  }

  // public async reserve() {
  //   // checkAPIを呼び出し
  //   const checkResult = await checkMedicalTreatmentSpot(
  //     this.reservationForm.clinic.medicalBusinessId,
  //     formatUuid(this.reservationForm.clinic.clinicId),
  //     formatUuid(this.reservationForm.treatmentSpotId)
  //   )
  //   if (checkResult.result) {
  //     const medicalTreatment = {
  //       customer: {
  //         phone_number: this.reservationForm.phoneNumber,
  //         last_name: '',
  //         first_name: '',
  //         last_name_kana: hiraganaToKatagana(this.reservationForm.lastName),
  //         first_name_kana: hiraganaToKatagana(this.reservationForm.firstName),
  //         birthday: formatDate(
  //           new Date(
  //             this.reservationForm.birthYear,
  //             this.reservationForm.birthMonth - 1,
  //             this.reservationForm.birthDate
  //           ),
  //           Constants.DateFormat.YYYY_MM_DD_HYPHEN
  //         ),
  //         sex: getSex()
  //       },
  //       treatment: {
  //         clinic_id: formatUuid(this.reservationForm.clinic.clinicId),
  //         clinica_department_id: formatUuid(
  //           this.reservationForm.clinic.clinicalDepartmentId
  //         ),
  //         is_first_treatment: 1, // TODO
  //         treatment_category_name: this.reservationForm.treatmentCategoryName,
  //         prior_consents: [],
  //         customer_description: this.reservationForm.comment,
  //         customer_describe_id: '',
  //         starts_at: checkResult.treatment.starts_at,
  //         ends_at: checkResult.treatment.ends_at,
  //         temporary_reservation_id: formatUuid(
  //           checkResult.temporary_reservation_id
  //         ),
  //         treatment_course_id: formatUuid(
  //           this.reservationForm.clinic.treatmentCourseId
  //         )
  //       }
  //     }
  //     // 診察登録APIを呼び出し
  //     const createResult = await createTreatment(
  //       this.reservationForm.clinic.medicalBusinessId,
  //       formatUuid(checkResult.temporary_reservation_id),
  //       medicalTreatment
  //     )
  //     if (createResult.result) {
  //       // 登録成功したら確認画面に遷移する
  //       this.$router.push({ name: RouteName.RESERVATION_COMPLETE })
  //     }
  //   }
  // }

  /**
   * 動的にscriptタグをbodyに追加して実行
   * @param id 成果識別子
   */
  private addAffiliagteTag(id: string) {
    const tempDiv = document.createElement('div')
    const script1 = document.createElement('script')
    script1.innerHTML = `a8sales({
      "pid": "s00000026045002",
      "order_number": "${id}",
      "currency": "JPY",
      "items": [
        {
          "code": "a8d_clinic",
          "price": 1,
          "quantity": 1
        }
      ],
      "total_price": 1
    });`

    const script2 = document.createElement('script')
    script2.innerHTML = `(function acsTrack(){
        var PV = "phsucsl7uz0a"
        var _ARGSV = "${id}"
        var KEYS = {cid : ["CL_", "ACT_", "cid_auth_get_type"], plid : ["PL_", "APT_", "plid_auth_get_type"]}
        var turl = "https://adco.jp/track.php?p=" + PV + "&args=" + _ARGSV
        var cks = document.cookie.split("; ").reduce(function(ret, s){ var kv = s.split("="); if(kv[0] && kv[1]) ret[kv[0]] = kv[1]; return ret; }, [])
        turl = Object.keys(KEYS).reduce(function(url, k){ var vk = KEYS[k][0] + PV; var tk = KEYS[k][1] + PV; var v = "", t = ""; if(cks[vk]){ v = cks[vk]; if(cks[tk]) t = cks[tk]; }else if(localStorage.getItem(vk)){ v = localStorage.getItem(vk); t = "ls"; } if(v) url += "&" + k + "=" + v; if(t) url += "&" + KEYS[k][2] + "=" + t; return url; }, turl)
        var xhr = new XMLHttpRequest(); xhr.open("GET", turl); xhr.send(); })();`

    const script3 = document.createElement('script')
    script3.innerHTML = `(function acsTrack(){
      var PV = "phttxjh6o870";
      var _ARGSV = "${id}";
      var KEYS = {cid : ["CL_", "ACT_", "cid_auth_get_type"]};
      var turl = "https://s15.aspservice.jp/royd/track.php?p=" + PV + "&args=" + _ARGSV;
      var cks = document.cookie.split("; ").reduce(function(ret, s){ var kv = s.split("="); if(kv[0] && kv[1]) ret[kv[0]] = kv[1]; return ret; }, []);
      turl = Object.keys(KEYS).reduce(function(url, k){ var vk = KEYS[k][0] + PV; var tk = KEYS[k][1] + PV; var v = "", t = ""; if(cks[vk]){ v = cks[vk]; if(cks[tk]) t = cks[tk]; }else if(localStorage.getItem(vk)){ v = localStorage.getItem(vk); t = "ls"; } if(v) url += "&" + k + "=" + v; if(t) url += "&" + KEYS[k][2] + "=" + t; return url; }, turl);
      var xhr = new XMLHttpRequest(); xhr.open("GET", turl); xhr.send(); })();`

    tempDiv.appendChild(script1)
    tempDiv.appendChild(script2)
    tempDiv.appendChild(script3)

    // scriptタグを抽出して実行
    const scriptElements = tempDiv.querySelectorAll('script')
    scriptElements.forEach(scriptElement => {
      const newScript = document.createElement('script')
      if (scriptElement.src) {
        newScript.src = scriptElement.src
      } else {
        newScript.textContent = scriptElement.innerHTML
      }
      document.body.appendChild(newScript) // 動的にscriptタグをbodyに追加して実行
    })
  }
}
